export const MERCH = [
    {
        id: "01",
        name: "HOT GIRLS LOVE BAR FLORIO",
        variant: "T-SHIRT",
        meta: "BSK SOUND — 2026",
        photo: "/assets/merch/tee-01-photo.jpg",
        flat: "/assets/merch/tee-01-flat.jpg",
        alt: "Model wearing the white Hot Girls Love Bar Florio t-shirt, back view",
    },
    {
        id: "02",
        name: "WORST PARTY IN TOWN",
        variant: "T-SHIRT",
        meta: "BSK SOUND — 2026",
        photo: "/assets/merch/tee-02-photo.jpg",
        flat: "/assets/merch/tee-02-flat.jpg",
        alt: "Model wearing the white Worst Party In Town t-shirt, back view",
    },
    {
        id: "03",
        name: "WORST PARTY IN TOWN",
        variant: "HOODIE",
        meta: "BSK SOUND — 2026",
        photo: "/assets/merch/tee-03-photo.jpg",
        flat: "/assets/merch/tee-03-flat.jpg",
        alt: "Model seated on a reflective floor wearing the black Worst Party In Town hoodie",
    },
    {
        id: "04",
        name: "SPIN SIP REPEAT",
        variant: "T-SHIRT",
        meta: "BSK SOUND — 2026",
        photo: "/assets/merch/tee-04-photo.jpg",
        flat: "/assets/merch/tee-04-flat.jpg",
        alt: "Model wearing the white Spin Sip Repeat t-shirt, back view",
    },
];

export const GRAPHICS = [
    { id: "G.01", title: "METAPHORA", meta: "POSTER — 2025", src: "/assets/graphic/g-01.jpg", alt: "Metaphora black and white event poster" },
    { id: "G.02", title: "LA NOTTE BIANCA", meta: "POSTER — 2025", src: "/assets/graphic/g-02.jpg", alt: "La Notte Bianca poster, Borgo Santa Caterina" },
    { id: "G.03", title: "SALETTA EDONÈ", meta: "VINYL LABEL — 2024", src: "/assets/graphic/g-03.jpg", alt: "Saletta Edonè vinyl label design" },
    { id: "G.04", title: "LA NOTTE BIANCA — CD", meta: "PACKAGING — 2025", src: "/assets/graphic/g-04.jpg", alt: "La Notte Bianca CD packaging design" },
    { id: "G.05", title: "METAPHORA × EDONÈ", meta: "POSTER — 2025", src: "/assets/graphic/g-05.jpg", alt: "Metaphora Edonè anniversary poster, red on dark" },
    { id: "G.06", title: "BSK SOUND — DJ SET", meta: "FLYER — 2024", src: "/assets/graphic/g-06.jpg", alt: "BSK Sound DJ set flyer with disco ball" },
    { id: "G.07", title: "6 APRILE 2024", meta: "POSTER — 2024", src: "/assets/graphic/g-07.jpg", alt: "Purple disco ball event poster" },
    { id: "G.08", title: "EN PLEIN AIR", meta: "FLYER — 2024", src: "/assets/graphic/g-08.jpg", alt: "BSK Sound En Plein Air flyer with cocktail illustration" },
];

export const EDITORIAL = [
    {
        id: "E.01",
        title: "INCIUCI",
        meta: "EDITORIAL PROJECT — 2024",
        video: "/assets/editorial/inciuci.mp4",
        poster: "/assets/editorial/inciuci-poster.jpg",
        alt: "INCIUCI magazine — yellow cover with puppet, rotating in 3D",
    },
    {
        id: "E.02",
        title: "DON'T PANIC",
        meta: "EDITORIAL PROJECT — 2024",
        video: "/assets/editorial/dont-panic.mp4",
        poster: "/assets/editorial/dont-panic-poster.jpg",
        alt: "DON'T PANIC magazine cover, rotating in 3D",
    },
];

export const FASHION_PROJECTS = [
    {
        id: "04.1",
        title: "HUMANITY ISSUE",
        meta: "COLLECTION — 2022",
        images: [
            { src: "/assets/fashion/f-01.jpg", alt: "The finished Humanity Issue garment — red hooded coat with black balaclava in a derelict building" },
        ],
    },
    {
        id: "04.2",
        title: "DISTRESSED EVELYNE",
        meta: "ACCESSORIES DESIGN — 2023",
        images: [
            { src: "/assets/fashion/f-05.jpg", alt: "The finished Distressed Evelyne white leather bag, held in a dark studio" },
        ],
    },
    {
        id: "04.3",
        title: "SYMBIOSIS",
        meta: "ACCESSORIES DESIGN — 2023",
        images: [
            { src: "/assets/fashion/f-07.jpg", alt: "The finished Symbiosis rings, black and silver, on a concrete floor" },
        ],
    },
];

export const CONTACTS = [
    { id: "email", label: "EMAIL", value: "marcogiavazzi14@gmail.com", href: "mailto:marcogiavazzi14@gmail.com" },
    { id: "phone", label: "PHONE", value: "+39 345 829 6240", href: "tel:+393458296240" },
    { id: "instagram", label: "INSTAGRAM", value: "@marco_giavaz", href: "https://instagram.com/marco_giavaz" },
];

export const NAV_LINKS = [
    { label: "WORK", href: "#work" },
    { label: "ABOUT", href: "#about" },
    { label: "CONTACT", href: "#contact" },
];

export const MARQUEE_TEXT =
    "WORST PARTY IN TOWN — HOT GIRLS LOVE BAR FLORIO — SPIN SIP REPEAT — BSK SOUND — MERCH — GRAPHIC DESIGN — ART DIRECTION — ";
